// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__12_HS","amount":"Amount_amount__3Stxv","tip":"Amount_tip__4lT9e","tipHeader":"Amount_tipHeader__iaxZv","tipsWrap":"Amount_tipsWrap__2KEnm"};